<div class="container" [formGroup]="filters">
  <div class="half-container">
    <p class="title">{{"IA_MONITORING" | translate}}</p>
    <p class="subtitle">{{"SUMMARY_MONITORING" | translate}}</p>

  </div>

  <div class="half-container">
    <div class="cardsContainer">
      <div class="card">
        <p class="textSelect">
          {{"incidentType" | translate}}
        </p>
        <div class="select">
          <mat-form-field color="white" appearance="outline">
            <mat-select #selIncidentType formControlName="incidentType" multiple>

              <mat-select-trigger>
                <span *ngIf="((filters.get('incidentType').value?.length || 0) == 1)">
                  {{ filters.get('incidentType').value[0]?.name || "SELECT_ALL" | translate }}
                </span>
                <span
                  *ngIf="((filters.get('incidentType').value?.length || 0) > 1 && filters.get('incidentType').value[0]?.name !== undefined)">
                  {{ filters.get('incidentType').value[0]?.name || "SELECT_ALL" | translate }}
                </span>

                <span
                  *ngIf="((filters.get('incidentType').value?.length || 0) > 1 && filters.get('incidentType').value[0]?.name == undefined)">
                  {{ filters.get('incidentType').value[1]?.name || "SELECT_ALL" | translate }}
                </span>

                <span *ngIf="((filters.get('incidentType').value?.length || 0) > 1)">
                  (+{{(filters.get('incidentType').value?.length || 0) - 1}} {{filters.get('incidentType')?.length === 2
                  ? '...' : '...'}})
                </span>
              </mat-select-trigger>

              <mat-option (click)="toggleAllSelection(selIncidentType)" [value]="0">{{ "SELECT_ALL" | translate
                }}</mat-option>
              <mat-option *ngFor="let option of arrayIncidentsTypes" [value]="option">{{option.name}}</mat-option>
            </mat-select>
          </mat-form-field>

        </div>

      </div>
      <div class="card">
        <p class="textSelect">
          {{ "ENTER_DATE_RANGE" | translate }}
        </p>
        <div class="selectDate">
          <mat-form-field appearance="outline" class="matformDate">

            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate formControlName="start" #dateRangeStart>
              <!-- (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)" -->
              <input matEndDate formControlName="end" #dateRangeEnd>
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>


        </div>

      </div>

      <div class="card">
        <p class="textSelect">
          {{ "SOURCES_DEV" | translate }}
        </p>
        <div class="select">
          <mat-form-field color="white" appearance="outline">
            <mat-select #selDevices formControlName="device" multiple>

              <mat-select-trigger>
                <span *ngIf="((filters.get('device').value?.length || 0) == 1)">
                  {{ filters.get('device').value[0]?.name || "SELECT_ALL" | translate }}
                </span>
                <span
                  *ngIf="((filters.get('device').value?.length || 0) > 1 && filters.get('incidentType').value[0]?.name !== undefined)">
                  {{ filters.get('device').value[0]?.name || "SELECT_ALL" | translate }}
                </span>

                <span
                  *ngIf="((filters.get('device').value?.length || 0) > 1 && filters.get('incidentType').value[0]?.name == undefined)">
                  {{ filters.get('device').value[1]?.name || "SELECT_ALL" | translate }}
                </span>

                <span *ngIf="((filters.get('device').value?.length || 0) > 1)">
                  (+{{(filters.get('device').value?.length || 0) - 1}} {{filters.get('incidentType')?.length === 2 ?
                  '...' : '...'}})
                </span>
              </mat-select-trigger>

              <!--<mat-option (click)="toggleAllSelection(selIncidentType)" [value]="0">{{ "SELECT_ALL" | translate }}</mat-option>-->
              <mat-option *ngFor="let option of arraySurcesDevices"
                [value]="option">{{option.sourcedevicE_NAME}}</mat-option>
            </mat-select>
          </mat-form-field>

        </div>

      </div>

    </div>
    <div class="card1">
      <button style=" height: 32px;
        background-color: #3FA9F5;
        color: white;" mat-raised-button (click)="getPerformanceMonitoring()">
        <span></span>
        {{ "SEARCH" | translate }}
      </button>

      <button style=" height: 32px;
        background-color: #3FA9F5;
        color: white;" class="confirm-ico-btn" mat-raised-button (click)="GoToIncidents()">
        <span></span>
        {{ "BTN_GO_INCIDENTS" | translate }}
      </button>
    </div>
  </div>
</div>

<div class="card-container">
  <div id="precision" class="card11 clickeable-card">
    <div class="">
      <img src="/assets/images/controlTowers/total2.png" alt="Imagen">
    </div>

    <div class="card-body">
      <div>
        <p class="card-title">

          Total

        </p>
      </div>
      <div>


        <p class="card-text">{{totalAcurracy}} %</p>
      </div>
      <div>

        <p class="cardSubText">Precision</p>
      </div>



    </div>


  </div>
  <div class="card11 clickeable-card" *ngFor="let kpi of Objmonitoring.kpis">
    <div class="imageCard">
      <img [src]="kpi.iconUrl" alt="Imagen">
    </div>
    <div class="card-body">
      <div>
        <p class="card-title">
          {{kpi.description}}
        </p>
      </div>
      <div>
        <p class="card-text">{{kpi.total}} %</p>
      </div>
      <div>
        <p class="cardSubText">{{kpi.label}}</p>
      </div>
    </div>
  </div>
</div>
<div class="chart-container-1">
  <canvas height="500" id="chart">{{chart}}</canvas>
</div>
<div style="text-align: right;">
  <button style=" height: 32px;
    background-color: #3FA9F5;
    color: white;" mat-raised-button class="button" (click)="checkSelection()">
    <span></span>
    {{ 'REGITSER_MONITORING' | translate}}
  </button>
</div>
<neoris-grid [ColumnsConfiguration]="gridColumnsConfigurationes" [Filter]="gFilter"
  [GridTitle]="'TEXT_MONITORING' | translate" [Data]="arrayGirdMonitoringGrid" [ShowChecks]="true"
  (cellClickEvent)="cellClick($event)"></neoris-grid>